import React, {useState, useRef} from 'react';
import JavascriptTimeAgo from 'javascript-time-ago';
import ReactTimeAgo from 'react-time-ago';
import en from 'javascript-time-ago/locale/en';
import DateTime from '../DateTime';

JavascriptTimeAgo.addLocale(en);

const TimeAgo = ({ className, dateTime, empty, dateTimeArgs = {} }) => {
    const [showRealTime, setShowRealTime] = useState(false);
    const timeout = useRef(null);

    const toggle = () => setShowRealTime(!showRealTime);

    const onMouseLeave = () => {
        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => setShowRealTime(false), 1000);
    };

    const onMouseEnter = () => {
        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => setShowRealTime(true), 100);
    }

    if (!dateTime) {
        return empty ?? null;
    }

    return <span onClick={toggle} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        {showRealTime ?
            <DateTime date={dateTime} className={className} {...dateTimeArgs} /> :
            <ReactTimeAgo className={'capitalize ' + className}
                date={new Date(dateTime.replace(' ', 'T'))}
            />
        }
    </span>
}

export default TimeAgo;
